import {countriesTranslation} from '@/plugins/Countries';
/**
 * Try to get a full country-name for a string that potentially contains a countrycode
 * @param a string that potentially contains a countrycode
 * @returns country-code in i18n-iso-countries format as string
 */
export default function(countryCode: string): string {
  return countriesTranslation[countryCode].toString();
}
